module.exports = __webpack_public_path__ + "assets/959fd26b193f0ff1cc1ae1edae355a11.png";